import { Radio } from 'antd';

import { styled } from '@mui/material';

export const RadioStyled = styled(Radio)`
  &:hover {
    .ant-radio-inner {
      border-color: ${({ theme }) => theme.vars.palette.primary.main};
    }
  }
  .ant-radio-checked {
    .ant-radio-inner {
      border-color: ${({ theme }) => theme.vars.palette.primary.main};
      background-color: ${({ theme }) => theme.vars.palette.primary.main};
    }
  }
`;
